export const GET_SUBSCRIPTION_PAGE_START = 'GET_SUBSCRIPTION_PAGE_START';
export const GET_SUBSCRIPTION_PAGE_SUCCESS = 'GET_SUBSCRIPTION_PAGE_SUCCESS';
export const GET_SUBSCRIPTION_PAGE_FAIL = 'GET_SUBSCRIPTION_PAGE_FAIL';

export const CREATE_SUBSCRIPTION_PAYMENT_START = 'CREATE_SUBSCRIPTION_PAYMENT_START';
export const CREATE_SUBSCRIPTION_PAYMENT_SUCCESS = 'CREATE_SUBSCRIPTION_PAYMENT_SUCCESS';
export const CREATE_SUBSCRIPTION_PAYMENT_FAILED = 'CREATE_SUBSCRIPTION_PAYMENT_FAILED';
export const SET_SUBSCRIPTION_PAYMENT_DATA = 'SET_SUBSCRIPTION_PAYMENT_DATA';

export const CREATE_SUBSCRIPTION_START = 'CREATE_SUBSCRIPTION_START';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const CREATE_SUBSCRIPTION_FAILED = 'CREATE_SUBSCRIPTION_FAILED';
export const SET_CREATED_SUBSCRIPTION_DATA = 'SET_CREATED_SUBSCRIPTION_DATA';

export const CLEAR_SUBSCRIPTION_PAYMENT_DATA = 'CLEAR_SUBSCRIPTION_PAYMENT_DATA';

export const SET_SUBSCRIPTION_VIEW = 'SET_SUBSCRIPTION_VIEW';

export const SET_DISPLAY_ADDRESS_FIELDS = 'SET_DISPLAY_ADDRESS_FIELDS';

export const SET_SUBSCRIPTION_SELECTED_CATEGORY = 'SET_SUBSCRIPTION_SELECTED_CATEGORY';

export const SET_SUBSCRIPTION_SELECTED_BANK_PAYMENT_METHOD =
  'SET_SUBSCRIPTION_SELECTED_BANK_PAYMENT_METHOD';
export const RESET_SUBSCRIPTION_SELECTED_BANK_PAYMENT_METHOD =
  'RESET_SUBSCRIPTION_SELECTED_BANK_PAYMENT_METHOD';
